import React, { FC, useState } from 'react';
import { FaSignOutAlt } from 'react-icons/fa';
import { useSelector } from 'react-redux';

//devextreem
import Button from 'devextreme-react/button';
import { Popup } from 'devextreme-react/popup';

import { RootStore } from 'bus/configureStore';

import ModalFooter from '../../../components/appModalFooter';
import { IAuth, useAuth } from '../../../context/auth';

type DetailModalRoleProps = {};

const DetailModalRole: FC<DetailModalRoleProps> = (props) => {
  const { signOut }: IAuth = useAuth();
  const { name: userName } = useSelector((store: RootStore) => store.auth.currentUser);

  const [visible, setVisible] = useState(false);

  const handleSubmit = (e: any) => {
    e.preventDefault && e.preventDefault();
    signOut!();
    setVisible(false);
  };

  const onShown = () => {};

  const onHidden = () => {};

  return (
    <div className="d-flex align-center">
      <div className="mr-2">{userName}</div>
      <Button width={90} type="normal" onClick={() => setVisible(true)} stylingMode="text">
        <div className="d-flex align-center" style={{ marginTop: 2 }}>
          <FaSignOutAlt style={{ marginRight: 10 }} />
          <span>Выйти</span>
        </div>
      </Button>

      <Popup
        visible={visible}
        onHiding={() => setVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Подтвердите действие"
        width={300}
        onShowing={() => onShown()}
        onHidden={() => onHidden()}
        height={160}
      >
        <div className="modal-block">
          <form onSubmit={handleSubmit}>
            <div className="modal-block__content">Вы действительно хотите выйти?</div>

            <ModalFooter
              typeConfirm="danger"
              textConfirm="Выйти"
              handleSubmit={handleSubmit}
              hideModal={() => setVisible(false)}
            />
          </form>
        </div>
      </Popup>
    </div>
  );
};

export default DetailModalRole;
